import { useSwitchNetwork } from 'wagmi'

import { Button, Modal } from 'primsell-shared-layer/components'
import APP_CONFIG from 'primsell-shared-layer/core/config'

import { SadFaceIcon } from 'primsell-shared-layer/assets/icons'

import * as S from './change-network-modal.styles'

const ChangeNetworkModal = (): JSX.Element => {
  const { error, isLoading, switchNetwork } = useSwitchNetwork()

  const handleSubmit = () => {
    switchNetwork?.(APP_CONFIG.chains[0].chainId)
  }

  return (
    <Modal>
      <Modal.Content>
        <SadFaceIcon />
        <S.Title>Wrong network</S.Title>
        <S.Description>{`In order to continue, please switch to a ${APP_CONFIG.chains[0].chainName} network`}</S.Description>
        {(isLoading || error) && <S.Description> Confirm network change in your wallet </S.Description>}
      </Modal.Content>
      {switchNetwork && error && (
        <Modal.Footer>
          <Button color="dark" variant="filled" onClick={handleSubmit} disabled={isLoading}>
            {`Change network to ${APP_CONFIG.chains[0].chainName}`}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  )
}

export { ChangeNetworkModal }
